import axios from '@/libs/axios'
import createCrtcreatorEntityStore from './createEntityStore'

const base = createCrtcreatorEntityStore({
  endpoint: 'api/modules/crtcreator/content',
})

const ENDPOINT = 'api/modules/crtcreator/content'

export default {
  ...base,
  state: {
    ...base.state,
    total: 0,
  },
  getters: {
    ...base.getters,
    total(state) {
      return state.total
    },
  },
  mutations: {
    ...base.mutations,
    SET_TOTAL(state, value) {
      state.total = Number(value) || 0
    },
  },
  actions: {
    ...base.actions,
    loadItems({ commit }, params = {}) {
      return axios.get(ENDPOINT, { params }).then((response) => {
        const payload = response.data || {}
        const data = payload.data ?? []
        const total = payload.meta?.total ?? data.length
        commit('SET_ITEMS', data)
        commit('SET_TOTAL', total)
        return {
          data,
          total: Number(total) || 0,
        }
      })
    },
  },
}
